import { booleanAttribute, ChangeDetectionStrategy, Component, DestroyRef, inject, input, model, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { NgxColorsModule } from 'ngx-colors';
import { debounceTime, distinctUntilChanged, Subject, throttleTime } from 'rxjs';

@Component({
  selector: 'app-color-input',
  template: `
    <ngx-colors ngx-colors-trigger 
                [ngModel]="value() ?? '#00000000'"
                (ngModelChange)="value.set($event)"
                (slider)="valueChangeFromSliderSubject.next($event)"
                colorsAnimation="popup"
                [disabled]="readonly() || disabled()"></ngx-colors>
  `,
  styles: [`
  body app-color-input {
    display: inline;
    line-height: 0;

    ngx-colors {
      display: inline-block;
    }
  }

  ngx-colors-panel .nav-wrapper button {
    display: none !important;
  }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NgxColorsModule, FormsModule]
})
export class ColorInputComponent {
  readonly destroyRef = inject(DestroyRef);

  readonly disabled = input(false, { transform: booleanAttribute });
  readonly readonly = input(false, { transform: booleanAttribute });

  readonly value = model('#00000000');

  readonly valueChangeFromSliderSubject = new Subject<string>();
  readonly valueChangeFromSlider = this.valueChangeFromSliderSubject.pipe(
    distinctUntilChanged(),
    throttleTime(20, null, { leading: true, trailing: true }),
    takeUntilDestroyed(this.destroyRef)
  ).subscribe(x => this.value.set(x));
}
